<template>
  <div>
    <v-tabs v-model="active">
      <v-tab :key="0">{{ $t("reservationsPage.tabActiveBlocks") }}</v-tab>
      <v-tab :key="1">{{ $t("reservationsPage.tabHistoricalBlocks") }}</v-tab>
    </v-tabs>
    <div>
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex xs6 style="padding: 8px" v-if="active == 1">
              <choose-date
                clearable
                :label="$t('reservationsPage.filterByDay')"
                v-model="date_filter"
              ></choose-date>
            </v-flex>
            <v-flex xs6 style="padding: 8px">
              <v-text-field
                v-model="search"
                append-icon="search"
                :label="$t('reservationsPage.username')"
                single-line
                hide-details
                @keyup.enter="getData"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="data"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :rows-per-page-items="[5, 10, 15, 25, 100]"
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr :class="[props.item.is_blocked == true && 'blocked']">
              <td class="text-xs-center">
                <span>{{ props.item.id }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ props.item.captain_id }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ props.item.captain_username }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ props.item.station_id }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ props.item.booking_id }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ formatDate(props.item.blocked_from) }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ formatDate(props.item.blocked_to) }}</span>
              </td>
              <td class="text-xs-center">
                <span>
                  {{ [$t("reservationsPage.no"), $t("reservationsPage.yes")][props.item.blocked] }}
                </span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import ChooseDate from "@/components/monaco/input/ChooseDate";
import LoadingComponent from "@/components/LoadingComponent";
import { toInteger } from "lodash";
import moment from "moment";
import { companyNow, formatCompanyTime } from "@/util/companyTime";

export default {
  name: "BlockedCaptains",
  title() {
    return this.$t("reservationsPage.blockedCaptainsTitle");
  },

  components: {
    ChooseDate,
    LoadingComponent,
  },
  data() {
    return {
      active: 0,
      date_filter: "",
      loading: false,
      search: "",
      items: [],
      data: [],
      totalItems: 0,
      pagination: {
        sortBy: "id",
        rowsPerPage: 25,
      },
      url: "blockLogs",
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("reservationsPage.colId"), value: "id", sortable: false, align: "center" },
        //  { text: "Username", value: "id", sortable: false, align: "center" },
        {
          text: this.$t("reservationsPage.colCaptainId"),
          value: "captain_id",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colCaptainUsername"),
          value: "captain_username",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colStationId"),
          value: "station_id",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colOrderId"),
          value: "booking_id",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colSuggestionTime"),
          value: "blocked_from",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colEndTime"),
          value: "blocked_to",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colBlocked"),
          value: "blocked",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  methods: {
    formatDate(date) {
      return formatCompanyTime(date, "DD-MM-YYYY HH:mm", "");
    },
    getData() {
      this.loading = true;
      const params = new URLSearchParams();

      params.delete("start");
      params.delete("end");
      if (this.active == 0) {
        this.start = companyNow().format("YYYY-MM-DD [00:00:00]");
        this.end = this.start.replace("00:00:00", "23:59:59");
        console.log(this.start, this.end);
        params.append("blocked_from", this.start);
        params.append("blocked_to", this.end);
      }
      if (this.date_filter != "Invalid date" && this.date_filter) {
        this.start = moment(this.date_filter).format("YYYY-MM-DD HH:mm:ss");

        this.end = moment(this.date_filter)
          .format("YYYY-MM-DD HH:mm:ss")
          .replace("00:00:00", "23:59:59");

        console.log("START");
        console.log(this.start);
        console.log(this.end);
      }
      params.append("page", this.pagination.page);
      params.append("perPage", String(this.pagination.rowsPerPage));
      // params.append("sortBy", String(this.pagination.sortBy));
      // params.append("descending", String(this.pagination.descending));
      // params.append("time", "RESERVATION");
      params.append("sortBy", "id");
      params.append("descending", true);
      if (this.date_filter) {
        params.append("blocked_from", this.start);
        params.append("blocked_to", this.end);
      }
      params.append("reservations", true);

      params.append("search", String(this.search));

      this.axios
        .get(this.url, { params })
        .then((res) => {
          console.log("data");
          console.log(res);
          this.data = res.data.data.data;
          // this.data = [
          //   {
          //     id: 1,
          //     captain_id: 2,
          //     blocked_from: "111",
          //     blocked_to: "111",
          //   },
          // ];
          this.totalItems = res.data.data.total;
          this.pagination.rowsPerPage = Number(res.data.data.per_page);
          this.loading = false;
          // window.getApp.$emit("SHOW_TOAST", "successfully");
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err, "red");
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    date_filter() {
      console.log(this.date_filter);
      this.getData();
    },
    active(val) {
      this.search = "";
      this.date_filter = "";

      console.log("START");
      console.log(this.start);
      console.log(this.end);
      this.getData();
    },
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.blocked {
  td {
    span {
      padding: 4px 6px;
      background-color: rgba(220, 39, 39, 0.08);
      border-radius: 4px;
      color: rgb(220, 39, 39);
    }
  }
}
</style>
